var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-menu-container"},[_c('AppSubmenu',{staticClass:"layout-menu",attrs:{"items":_vm.model,"root":true},on:{"menuitem-click":_vm.onMenuItemClick,"keydown":_vm.onKeyDown}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }